import { type ReactNode } from "react";
import { cn } from "../../lib/utils";

type PartnershipBannerProps = {
  /** Banner content — typically a short disclaimer string */
  children: ReactNode;
  /** Background fill. Falls back to the primary-black token when null. */
  backgroundColor: string | null;
  /** Text color. Falls back to white when null. */
  textColor: string | null;
  /** Extra classes merged onto the banner element (e.g. sticky positioning) */
  className?: string;
};

function PartnershipBanner({
  children,
  backgroundColor,
  textColor,
  className,
}: PartnershipBannerProps): React.JSX.Element {
  return (
    <div
      className={cn(
        "py-3 bg-primary-black text-white font-dm-sans text-[11px] font-semibold leading-[15px] text-center",
        className
      )}
      style={{
        backgroundColor: backgroundColor === null ? undefined : backgroundColor,
        color: textColor === null ? undefined : textColor,
      }}
    >
      {children}
    </div>
  );
}

export { PartnershipBanner, type PartnershipBannerProps };
